import type { ReactNode } from 'react';

// Kicker — small uppercase tertiary label rendered above section titles, KPIs,
// or anywhere the design philosophy specifies a 11px kicker. Uses the global
// `.kicker` recipe so all kickers stay consistent across the app.
type KickerProps = {
  /** Set by `<Commentable>` (cloneElement); forwarded to the root element so the anchor reaches the DOM. */
  'data-comment-anchor'?: string;
  children: ReactNode;
  className?: string;
};

export function Kicker({ children, className, 'data-comment-anchor': commentAnchor }: KickerProps) {
  const cls = ['kicker', className].filter(Boolean).join(' ');
  return (
    <span data-comment-anchor={commentAnchor} className={cls}>
      {children}
    </span>
  );
}
